import React from "react";
import "./CorporateFilms.css";
import GRImg from "../../assets/CopprateFilms/Copy of G&R Group upscale.jpg";
import JioImg from "../../assets/CopprateFilms/Copy of Jio Upscale.jpg";

const corporateGroups = [
  {
    title: "G&R GROUP",

    description:
      "A corporate film showcasing the people behind one of India's leading retail franchise networks.",

    note:
      "I came back with footage. Almost came back with half a dozen new sneakers too.",

    items: [
      {
        title: "BUILDING PARTNERSHIPS. DRIVING GROWTH.",
        category: "CORPORATE FILM",
        image: GRImg,
      },
    ],
  },

  {
    title: "JIO BHARAT",

    description:
      "A corporate film highlighting how affordable technology can bring millions into the digital world.",

    note:
      "Turns out you don't need an expensive phone to ignore my texts.",

    items: [
      {
        title: "CONNECTING INDIA. EMPOWERING TOMORROW.",
        category: "CORPORATE FILM",
        image: JioImg,
      },
    ],
  },
];

const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "PODCASTS & INTERVIEWS",
  "EVENTS",
  "SOCIAL AND VERTICAL FILMS",
  "PHOTOGRAPHY CREATIVE",
];
function pad(num) {
  return String(num).padStart(2, "0");
}
function CorporateFilms() {
  const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};

  return (
    <main className="corporate-page">

      <div className="corporate-shell">

        {/* =====================================
            HEADER
        ===================================== */}

        <header className="corporate-main-header">

          <h1 className="corporate-main-title">
            CORPORATE FILMS
          </h1>

          <div className="corporate-main-rule">
           <span>STORIES WITH PURPOSE</span>
          </div>

        </header>


        {/* =====================================
            CORPORATE CONTENT
        ===================================== */}

        <div className="corporate-content">

     {corporateGroups.map((group, groupIndex) => (

  <section
    className="corporate-group"
    key={group.title}
  >

    <div className="corporate-group-heading">

      <div className="corporate-group-number">
        {pad(groupIndex + 1)}
      </div>

      <div className="corporate-group-title-wrap">

        <span className="corporate-group-label">
          CORPORATE STORY
        </span>

        <h2>
          {group.title}
        </h2>

      </div>

      <div className="corporate-group-line"></div>

    </div>


    <div className="corporate-group-copy">

      <p className="corporate-group-description">
        {group.description}
      </p>

      <p className="corporate-group-note">
        {group.note}
      </p>

    </div>


    <div className="corporate-grid">

      {group.items.map((item) => (

        <article
          className="corporate-card"
          key={item.title}
          tabIndex={0}
        >

          <img
            src={item.image}
            alt={item.title}
            className="corporate-card-image"
          />

          <div className="corporate-card-overlay"></div>

          <button
            type="button"
            className="corporate-play"
            aria-label={`Play ${item.title}`}
          >
            <span></span>
          </button>

          <div className="corporate-card-info">

            <h3>
              {item.title}
            </h3>

            <p>
              {item.category}
            </p>

          </div>

        </article>

      ))}

    </div>

  </section>

))}

        </div>


        {/* =====================================
            BOTTOM CATEGORY NAV
        ===================================== */}

        <nav className="corporate-category-bar">

          {/* LEFT */}

          <button
            className="corporate-nav-arrow"
            onClick={() =>
              goToCategory("COMMERCIALS")
            }
            aria-label="Previous category"
          >
            &larr;
          </button>


          {/* CATEGORIES */}

          <div className="corporate-category-list">

            {categories.map((category) => (

              <button
                key={category}
                type="button"
                className={`corporate-category ${category === "CORPORATE FILMS"
                  ? "active"
                  : ""
                  }`}
                onClick={() =>
                  goToCategory(category)
                }
              >
                {category}
              </button>

            ))}

          </div>


          {/* RIGHT */}

          <button
            className="corporate-nav-arrow"
            onClick={() =>
              goToCategory("DOCUMENTARIES")
            }
            aria-label="Next category"
          >
            &rarr;
          </button>

        </nav>

      </div>

    </main>
  );
}

export default CorporateFilms;